import { Component, OnInit,ElementRef } from '@angular/core';
import { SiteConfigurationService } from '../../common/site-configuration.service'; 
import { RouterModule, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'tnsitefooter',
  templateUrl: '../../themes/default/html/tnsitefooter.component.html',
  styleUrls: ['../../themes/default/css/tnsitefooter.component.scss']
})
export class TnsitefooterComponent implements OnInit {

  FooterData: any = "";
  _mySettings: any;
  myMenu = {
    Home: 'Home',
    Ads: 'Immobili',
    AboutUs: 'Chi Siamo',
    Service: 'Servizi',
    News: 'News',
    Privacy: 'Privacy',
    Contact: 'Contatti'
  };

  currentUrl: string;

  constructor(private mySettings: SiteConfigurationService,private elementRef:ElementRef, private router: Router) { 
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
      
    this._mySettings = mySettings.getFullConfig();
    this.FooterData = this._mySettings.e400.site.footer.it;
  
}

  ngOnInit() {



  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnsitefooter/tnsitefooter.component.ts